import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactSVG } from 'react-svg'
import Typography from '@material-ui/core/Typography'
import MobileModal from 'components/MobileModal/MobileModal'
import ResetMyPasswordForm from 'components/ResetMyPasswordForm/ResetMyPasswordForm'
import ICON_SUCCESS from 'assets/images/icons-success.svg'
import useStyles from './styles'

const ResetMyPasswordMobileModal = ({ open = false, handleClose, title, userId }) => {
  const classes = useStyles()
  const [finished, setFinished] = useState(false)

  const handleFinished = (value) => {
    setFinished(value)
  }

  const handleCloseAndFinish = () => {
    handleClose()
    setFinished(false)
  }

  return (
    <MobileModal open={open} handleClose={handleClose} title={title}>
      {!finished ? (
        <ResetMyPasswordForm userId={userId} handleClose={handleCloseAndFinish} handleFinished={handleFinished} />
      ) : (
        <div className={classes.successContainer}>
          <ReactSVG src={ICON_SUCCESS} className={classes.image} />
          <Typography className={classes.textSuccess}>
            <FormattedMessage id={'Profile.modal.success'} />
          </Typography>
        </div>
      )}
    </MobileModal>
  )
}

export default ResetMyPasswordMobileModal
